import axios from "axios";
import { retreadingTransactionFormValuesApiMapper } from "../../../helpers/retreadingTransactionFormValuesApiMapper";
import { RetreadingTransactionFormContent } from "../../../types";

export const addRetreadingTransaction = (
  values: RetreadingTransactionFormContent
) => {
  const requestBody = retreadingTransactionFormValuesApiMapper(values);

  return axios
    .post("transactions/retreader", requestBody)
    .then(({ data }) => data);
};

export default {
  addRetreadingTransaction,
};
